const DateCompare = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  CUSTOM: 'custom',
};

const PresetDate = {
  DAY: 'TODAY',
  WEEK: 'CURRENT_WEEK',
  MONTH: 'CURRENT_MONTH',
};

const TrendMetricsDate = {
  DAY: 'DAILY',
  WEEK: 'WEEKLY',
  MONTH: 'MONTHLY',
  CUSTOM: 'CUSTOM',
};

type DateCompareType = (typeof DateCompare)[keyof typeof DateCompare];
type PresetDateType = (typeof PresetDate)[keyof typeof PresetDate];
type TrendMetricType = (typeof TrendMetricsDate)[keyof typeof TrendMetricsDate];

export function convertDateCompareToPreset(
  dateCompare: DateCompareType
): PresetDateType | undefined {
  const key = Object.keys(DateCompare).find(
    k => DateCompare[k as keyof typeof DateCompare] === dateCompare
  );
  return key ? PresetDate[key as keyof typeof PresetDate] : undefined;
}

export function convertDateCompareToTrendMetrics(
  dateCompare: DateCompareType
): TrendMetricType | undefined {
  const key = Object.keys(DateCompare).find(
    k => DateCompare[k as keyof typeof DateCompare] === dateCompare
  );
  return key
    ? TrendMetricsDate[key as keyof typeof TrendMetricsDate]
    : undefined;
}

export default DateCompare;
